// extracted by mini-css-extract-plugin
export default {"fixedNavigation":"FixedNavigation_fixedNavigation__dDLid","svg":"FixedNavigation_svg__GW0v8"};